var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaQdark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99999 11.25C4.30232 11.25 3.8372 10.7917 3.8372 10.1042V8.95833C3.8372 8.27083 4.30232 7.8125 4.99999 7.8125C6.51162 7.8125 7.67442 6.66667 7.67442 5.17708C7.67442 3.6875 6.51162 2.54167 4.99999 2.54167C3.48838 2.54167 2.32558 3.6875 2.32558 5.17708C2.32558 5.86458 1.86047 6.32292 1.16279 6.32292C0.465117 6.32292 0 5.86458 0 5.17708C0 2.42708 2.2093 0.25 4.99999 0.25C7.79069 0.25 10 2.42708 10 5.17708C10 7.46875 8.37209 9.41667 6.16279 9.98958V10.1042C6.16279 10.7917 5.69767 11.25 4.99999 11.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8335 15.75C4.2335 15.75 3.8335 15.35 3.8335 14.75V13.75C3.8335 13.15 4.2335 12.75 4.8335 12.75C5.4335 12.75 5.8335 13.15 5.8335 13.75V14.75C5.8335 15.35 5.4335 15.75 4.8335 15.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaQdark);
export default __webpack_public_path__ + "static/media/FAQdark.042e1444c7eb6a83521e0fac64f0f258.svg";
export { ForwardRef as ReactComponent };